<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="productIntroductionTemplateGroup.pkid > 0 ? '编辑分组':'新建分组'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="productIntroductionTemplateGroup"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="分组名称">
            <el-input v-model="productIntroductionTemplateGroup.groupName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="分组类型">
            <el-select v-model.trim="productIntroductionTemplateGroup.groupType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.groupType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  @click.native="selectTemplate(item)"/>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <div slot="toolbar">
          <el-button
              v-if="productIntroductionTemplateGroup.groupType>0"
              type="primary"
              style="margin-bottom: 3%"
              @click="$refs.editpage.open(null,-1,productIntroductionTemplateGroup.groupType)">
            +新建
          </el-button>
        </div>
        <el-table
            v-if="productIntroductionTemplateGroup.groupType===10"
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column prop="paramIndex" align="center" label="显示顺序"/>
          <el-table-column prop="paramName" align="center" label="参数标题"/>
          <el-table-column prop="paramValueType" align="center" label="参数值类型">
            <template slot-scope="scope">
              <span v-if="scope.row.paramValueType===10" style="color: #2D8CF0">
                字符类型
              </span>
              <span v-if="scope.row.paramValueType===20" style="color: #2D8CF0">
                枚举类型
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="paramValue" align="center" label="参数值"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button type="primary" @click.native.prevent="$refs.editpage.open(scope.row,scope.$index,productIntroductionTemplateGroup.groupType)">编辑</el-button>
              <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            v-if="productIntroductionTemplateGroup.groupType===20"
            :data="tableData2"
            border
            style="width: 100%">
          <el-table-column prop="paramIndex" align="center" label="显示顺序"/>
          <el-table-column prop="paramName" align="center" label="表头名称"/>
          <el-table-column prop="paramValue" align="center" label="参数值"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button type="primary" @click.native.prevent="$refs.editpage.open(scope.row,scope.$index,productIntroductionTemplateGroup.groupType)">编辑</el-button>
              <el-button type="danger" @click="oneDelete2(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <product-introduction-template-param-edit ref="editpage" @save-success="getList"/>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import ProductIntroductionTemplateParamEdit
    from "@/views/information/ProductIntroductionTemplate/productIntroductionTemplateParamEdit";

  export default {
    name:"ProductIntroductionTemplateGroupEdit",
    components: {ProductIntroductionTemplateParamEdit},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        index: "",
        tableData:[],
        tableData2:[],
        deleteIds:[],
        deleteIds2:[],
        groupType:"",
        productIntroductionTemplateGroup: {
          pkid: "",
          masterPKID: "",
          groupIndex: "",
          groupName: "",
          groupType: "",
          productIntroductionTemplateParams:[],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row,index) {
        this.index = index;
        this.dialogVisible = true;
        if(row) {
          this.productIntroductionTemplateGroup = row;
          this.groupType = row.groupType;
          if (row.groupType===10) {
            this.tableData = row.productIntroductionTemplateParams;
          }else {
            this.tableData2 = row.productIntroductionTemplateParams;
          }
        }
      },
      getList(row,index,type) {
        if (type===10) {
          if(index >= 0) {
            this.tableData[index].pkid = row.pkid;
            this.tableData[index].paramIndex = index+1;
            this.tableData[index].paramName = row.paramName;
            this.tableData[index].paramValueType = row.paramValueType;
            this.tableData[index].paramValue = row.paramValue;
          }else{
            console.log("tableData" + this.tableData);
            console.log("tableData2" + this.tableData2);
            this.tableData.push({pkid:0,paramIndex: this.tableData.length+1,paramName: row.paramName, paramValueType: row.paramValueType, paramValue: row.paramValue});
          }
        }else {
          if(index >= 0) {
            this.tableData2[index].pkid = row.pkid;
            this.tableData2[index].paramIndex = index+1;
            this.tableData2[index].paramName = row.paramName;
            // this.tableData2[index].paramValueType = row.paramValueType;
            this.tableData2[index].paramValue = row.paramValue;
          }else{
            this.tableData2.push({pkid:0,paramIndex: this.tableData2.length+1,paramName: row.paramName, paramValue: row.paramValue});          }
        }
      },
      handleSubmit() {
        let ids = [];
        if (this.productIntroductionTemplateGroup.groupType===10) {
          ids = this.deleteIds;
          this.productIntroductionTemplateGroup.productIntroductionTemplateParams = this.tableData;
        }else {
          ids = this.deleteIds2;
          this.productIntroductionTemplateGroup.productIntroductionTemplateParams = this.tableData2;
        }
        if(this.index<0) {
          this.dialogVisible = false;
          this.$emit("save-success",this.productIntroductionTemplateGroup,-1,ids);
        }else {
          this.dialogVisible = false;
          this.$emit("save-success",this.productIntroductionTemplateGroup,this.index,ids);
        }
      },
      selectTemplate(item) {
        this.productIntroductionTemplateGroup.groupType = item.value;
        let pkids = [];
        for (let item of this.productIntroductionTemplateGroup.productIntroductionTemplateParams) {
          pkids.push(item.pkid);
        }
        console.log(item.value);
        if (item.value===10 && item.value !== this.groupType) {
          this.tableData2 = [];
          this.deleteIds2 = pkids;
        }else if (item.value===20 && item.value !== this.groupType) {
          this.tableData = [];
          this.deleteIds = pkids;
        }
      },
      //页面删除
      oneDelete(index,row) {
        this.tableData.splice(index,1);
        if(row.pkid) {
          this.deleteIds.push(row.pkid);
        }
        this.tableData.forEach((item, index) => {
          item.paramIndex = index+1;
        });
      },
      oneDelete2(index,row) {
        this.tableData2.splice(index,1);
        if(row.pkid) {
          this.deleteIds2.push(row.pkid);
        }
        this.tableData2.forEach((item, index) => {
          item.paramIndex = index+1;
        });
      },
      //数据库真正删除
      delete() {
        this.$http
          .delete("basic","/ProductIntroductionTemplateGroups/idList",this.deleteIds).then(() => {
            this.deleteIds = [];
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
